import React from 'react';
import { Grid, Dialog, DialogContent, Button, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import SuccessIcon from '@mui/icons-material/CheckCircle';

import { ModalActions } from '@/RestoreComponent/ModalActions';
import { Membership } from './EditMembership';
import moment from 'moment';

const useStyles: any = makeStyles(theme => ({
  content: {
    paddingBottom: 6
  },
  statusContainer: {
    width: 554,
    paddingLeft: 4
  },
  status: {
    width: 74,
    margin: 'auto'
  },
  summaryText: {
    textAlign: 'center',
    padding: '18px 0'
  },
  customerInfo: {
    fontSize: 14,
    fontWeight: 400
  },
  instructions: {
    fontSize: 14,
    fontWeight: 400,
    textAlign: 'center',
    margin: '0 24px',
    letterSpacing: 0.35,
    wordSpacing: 0.25
  },
  success: {
    height: 64,
    width: 64,
    paddingLeft: 14,
    paddingTop: 14,
    backgroundColor: theme.palette.success[50],
    borderRadius: 31,
    '& svg': {
      height: 34,
      width: 34,
      color: theme.palette.success[600]
    }
  }
}));

export interface MembershipCustomer {
  id: number;
  firstName: string;
  lastName: string;
  email?: string;
  dob?: string;
}

type ConfirmModalProps = {
  onClose: (o: boolean) => void;
  isOpen: boolean;
  customerData: MembershipCustomer;
  customerMembership: Membership;
  freezeStartDate: string;
  freezeDuration: number; // months
};

export const FreezeMembershipConfirmation: React.FC<ConfirmModalProps> = ({
  isOpen,
  onClose,
  customerData,
  customerMembership,
  freezeStartDate,
  freezeDuration
}) => {
  const classes = useStyles();

  const dob = moment(customerData.dob).format('MM/DD/YYYY');
  const customerName = `${customerData.firstName} ${customerData.lastName}`;
  const freezeStart = moment(freezeStartDate).format('MM/DD/YYYY');
  const freezeEnd = moment(freezeStartDate)
    .add(freezeDuration, 'months')
    .format('MM/DD/YYYY');

  return (
    <Dialog open={isOpen} onClose={close}>
      <DialogContent className={classes.content}>
        <Grid container>
          <Grid item sm={12}>
            <div className={classes.statusContainer}>
              <>
                <div className={classes.status}>
                  <div className={classes.success}>
                    <SuccessIcon />
                  </div>
                </div>
                <div className={classes.summaryText}>
                  <Typography variant="h3">
                    Freeze Membership Confirmation
                  </Typography>
                  <p className={classes.customerInfo}>
                    {customerName} - DOB {dob} -&nbsp;
                    {customerData.email}
                  </p>
                </div>
              </>
            </div>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item sm={12}>
            <p className={classes.instructions}>
              {customerName}'s {customerMembership.description} membership will
              be frozen from {freezeStart} until {freezeEnd}. Once acknowledged,
              this freeze is active and counts towards the 1 per year freeze
              policy. An email will be sent to {customerData.email} for
              confirmation to the client.
            </p>
          </Grid>
        </Grid>
        <Grid container my={3}>
          <Grid item sm={12}>
            <p className={classes.instructions}>
              Acknowledge the confirmation or Cancel to return to freeze
              process.
            </p>
          </Grid>
        </Grid>
      </DialogContent>
      <ModalActions>
        <Button
          className={classes.actions}
          variant="outlined"
          color="primary"
          onClick={() => onClose(false)}
        >
          Cancel
        </Button>
        <Button
          className={classes.actions}
          variant="contained"
          color="primary"
          onClick={() => onClose(true)}
        >
          Acknowledge
        </Button>
      </ModalActions>
    </Dialog>
  );
};
